export default __webpack_public_path__ + "static/media/LoginImage.4f83b99d.png";